import { Box, Typography } from "@mui/material";
import { ReactComponent as ChevronDownIcon } from "components/Icons/chevron-down.svg";
import { useMessage } from "hooks/intl";
import { useState } from "react";
import { LabelValuePair } from "utilities/objects";
import { useStyles } from "./AdvancedSettingsBar.styles";

interface Props {
  labels: LabelValuePair[];
  advancedSettingsClass?: string;
  vectorMarginClass: string;
  variant?: "box" | "text";
}

export const AdvancedSettingsBar = ({
  labels,
  advancedSettingsClass = "",
  vectorMarginClass,
  variant = "box",
}: Props) => {
  const [isAdvancedSettingsBarOpen, setIsAdvancedSettingsBarOpen] =
    useState(false);

  const classes = useStyles({ isAdvancedSettingsBarOpen });
  const { message } = useMessage();

  const handleAdvancedSettingsArrowClick = () =>
    setIsAdvancedSettingsBarOpen(!isAdvancedSettingsBarOpen);

  return (
    <Box className={classes.container}>
      <Box className={`${classes.vector} ${vectorMarginClass}`}></Box>
      <Box
        className={`${classes.advancedSettingsContainer} ${advancedSettingsClass}`}
      >
        <Box className={classes.flexWrapper}>
          <Typography className={classes.typo500}>
            {message({ id: "advancedSettings" })}
          </Typography>
          <ChevronDownIcon
            className={classes.arrowIcon}
            onClick={handleAdvancedSettingsArrowClick}
          />
        </Box>
        {isAdvancedSettingsBarOpen
          ? labels.map((item) =>
              typeof item.value === "string" ? (
                <Box key={item.label} className={classes.flexWrapper}>
                  <Typography className={classes.typo400}>
                    {item.label}
                  </Typography>
                  {variant === "box" ? (
                    <Box className={classes.chips}>{item.value}</Box>
                  ) : (
                    item.value
                  )}
                </Box>
              ) : null,
            )
          : null}
      </Box>
    </Box>
  );
};
